'use client';

import { createContext } from 'react';

import { useAuthState } from './use-auth-state';

export type AuthContextProps = ReturnType<typeof useAuthState>;

export const AuthContext = createContext<AuthContextProps | null>(null);
